/*
 * @Description: 任务有礼
 * @Author: your name
 * @Date: 2021-08-05 19:04:22
 * @LastEditTime: 2021-08-11 17:24:27
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 */

import http from '@/plugin/axios';
// import { Apis } from '../index';

export default {
    /**
     * 问卷互答空间
     */
     getSpaceList: (data: any): Promise<any> => {
        return http.post('/activity/space/getSpaceList', data);
    },
    /**
     * 已参与项目
     */
     getParticipationSpacePage: (data: any): Promise<any> => {
        return http.post('/activity/space/getParticipationSpacePage', data);
    },
    /**
     * 已发布到空间
     */
     getReleaseQuestionPage: (data: any): Promise<any> => {
        return http.post('/activity/space/getReleaseQuestionPage', data);
    },
    /**
     * 已发布到空间
     */
     getBalancePayCoin: (data: any): Promise<any> => {
        return http.post('/active/pay/getBalancePayCoin', data);
    },
    /**
     * 空间发布
     */
     getSpaceRelease: (data: any): Promise<any> => {
        return http.post('/activity/space/getSpaceRelease', data);
    },
    /**
     * 退出空间
     */
     getSpaceExit: (data: any): Promise<any> => {
        return http.post('/activity/space/getSpaceExit', data);
    },
}
